/*
 * VARNA — Summer 27 cart pre-order notice
 */

(function () {
  const collectionUrl = '/collections/summer-27/products.json?limit=250';
  const noticeSelector = '[data-varna-preorder-notice]';

  const message = `
    <div style="padding: 12px 16px; font-size: 12px; line-height: 1.6;">
      <p style="margin: 0 0 8px;">
        SUMMER 27 — VARNA FRIENDS PRE-ORDER
      </p>
      <p style="margin: 0;">
        A piece worth waiting for. Your selection will be dispatched in February 2027.
      </p>
    </div>
  `;

  let summerProductsPromise;
  let updating = false;
  let timer;

  function getSummerProducts() {
    if (!summerProductsPromise) {
      summerProductsPromise = fetch(collectionUrl)
        .then(response => {
          if (!response.ok) throw new Error('Collection unavailable');
          return response.json();
        })
        .then(data => new Set(
          (data.products || []).map(product => product.id)
        ))
        .catch(error => {
          summerProductsPromise = null;
          throw error;
        });
    }

    return summerProductsPromise;
  }

  async function updateNotice() {
    if (updating) return;

    const notice = document.querySelector(noticeSelector);
    if (!notice) return;

    updating = true;

    try {
      const [summerProducts, cart] = await Promise.all([
        getSummerProducts(),
        fetch('/cart.js', { cache: 'no-store' })
          .then(response => response.json())
      ]);

      const hasSummer27 = cart.items.some(item =>
        summerProducts.has(item.product_id)
      );

      if (hasSummer27) {
        notice.innerHTML = message;
      } else {
        notice.innerHTML = '';
      }
    } catch (error) {
      console.warn('VARNA pre-order notice:', error);
    } finally {
      updating = false;
    }
  }

  function scheduleUpdate() {
    clearTimeout(timer);
    timer = setTimeout(updateNotice, 350);
  }

  const observer = new MutationObserver(scheduleUpdate);

  function initialise() {
    const cartDrawer = document.querySelector('cart-items');

    if (cartDrawer) {
      observer.observe(cartDrawer, {
        childList: true,
        subtree: true
      });
    }

    updateNotice();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise);
  } else {
    initialise();
  }
})();